import React from 'react'; 
import './FeaturedCars.css';

import { Car } from '../../components';
import { cars } from '../../constants';
import { getPopular } from '../../utils';

// import Swiper core and required modules 
import { Autoplay } from 'swiper/modules';
 
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles  
import 'swiper/css';



const FeaturedCars = () => {

  const popular = getPopular(cars); // Get the Popular Cars from the cars array
  const popularCars = popular.slice(0, 6); // Selecting only the top 6 popular cars

  return (
    <div className='featuredCar-slider'>
      <Swiper 
        // install Swiper modules
        modules={[Autoplay]}
        spaceBetween={10} // Space between slides
        loop={true} // Enable infinite loop
        autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          1025: { slidesPerView: 3 }, // 3 slides for larger screens
        }}
      >
        {// Mapping through the popularCars array to create slides
          popularCars.map((car, index) => { 
            return (
              <SwiperSlide key={index}> 

                <Car car={car} /> {/* Rendering Car component */}

              </SwiperSlide>
            )
          })
        }

      </Swiper>
    </div>
  )
}

export default FeaturedCars;